import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.min.css';
import slide1 from 'src/assets/images/1.svg';
import slide2 from 'src/assets/images/2.svg';
import slide3 from 'src/assets/images/3.svg';
import slide4 from 'src/assets/images/4.svg';
import slide5 from 'src/assets/images/5.svg';

import SwiperCore, { Autoplay, Pagination, Navigation } from 'swiper';
SwiperCore.use([Autoplay, Pagination, Navigation]);

const SlideImage = () => {
  return (
    <Swiper
      spaceBetween={30}
      centeredSlides={true}
      autoplay={{
        delay: 4000,
        disableOnInteraction: false,
      }}
      pagination={{
        clickable: true,
      }}
      className="mySwiper h-100"
      speed={750}
      loop={true}
    >
      <SwiperSlide className="h-100 text-center">
        <img src={slide1} alt="" className="h-100" />
      </SwiperSlide>
      <SwiperSlide className="h-100 text-center">
        <img src={slide2} alt="" className="h-100" />
      </SwiperSlide>
      <SwiperSlide className="h-100 text-center">
        <img src={slide3} alt="" className="h-100" />
      </SwiperSlide>
      <SwiperSlide className="h-100 text-center">
        <img src={slide4} alt="" className="h-100" />
      </SwiperSlide>
      <SwiperSlide className="h-100 text-center">
        <img src={slide5} alt="" className="h-100" />
      </SwiperSlide>
    </Swiper>
  );
};

export default SlideImage;
